import React, { useState } from "react";
import InnerLayout from "./InnerLayout";

const klsOfficeBearers = [
  {
    slNo: "1",
    name: "Shri. Pradeep Sawkar",
    role: "President",
    image: "/Board_members/P.S.Sawkar-President.jpg",
  },
  {
    slNo: "2",
    name: "Shri. Ram Bhandare",
    role: "Vice-President",
    image: "/Board_members/Shri.Ram.Bhandare-Vice-President.jpg",
  },
  {
    slNo: "3",
    name: "Shri. Deepak V. Kulkarni",
    role: "Vice-President",
    // image: "/KLS/deepak-v-kulkarni.jpg",
  },
  {
    slNo: "4",
    name: "Shri. Anant K Tagare",
    role: "Chairman",
    image: "/Board_members/Shri.A.K.Tagare-Chairman.jpg",
  },
  {
    slNo: "5",
    name: "Shri. V. M. Deshpande",
    role: "Secretary",
    image: "/Board_members/Shri.V.M.Deshpande-Secretary.jpg",
  },
  {
    slNo: "6",
    name: "Shri. S. V. Ganachari",
    role: "Secretary",
    image: "/Board_members/Shri.S.V.Ganachari-Secretary.jpg",
  },
  {
    slNo: "7",
    name: "Shri. Prakash G. Badkundri",
    role: "Member",
    // image: "/KLS/prakash-g-badkundri.jpg",
  },
  {
    slNo: "8",
    name: "Shri. U. N. Kalkundrikar",
    role: "Member",
    // image: "/KLS/u-n-kalkundrikar.jpg",
  },
  {
    slNo: "9",
    name: "Shri. Rajendra Belgaumkar",
    role: "Member",
    // image: "/KLS/rajendra-belgaumkar.jpg",
  },
  {
    slNo: "10",
    name: "Shri. R. S. Mutalik",
    role: "Member",
    // image: "/KLS/r-s-mutalik.jpg",
  },
  {
    slNo: "11",
    name: "Shri. S. P. Joshi",
    role: "Member",
    // image: "/KLS/s-p-joshi.jpg",
  },
  {
    slNo: "12",
    name: "Shri. Atul Alur",
    role: "Member",
    // image: "/KLS/atul-alur.jpg",
  },
  {
    slNo: "13",
    name: "Shri. Ashok A. Kulkarni",
    role: "Member",
    // image: "/KLS/ashok-a-kulkarni.jpg",
  },
  {
    slNo: "14",
    name: "Shri. Vivek Kulkarni",
    role: "Member",
    // image: "/KLS/vivek-kulkarni.jpg",
  },
  {
    slNo: "15",
    name: "Shri. Prashant Kulkarni",
    role: "Member",
    // image: "/KLS/prashant-kulkarni.jpg",
  },
];

const governingCouncil = [
  ["1", "Shri Prashant Kulkarni", "GC-Chairman"],
  ["2", "Shri V. M. Deshpande", "Member Secretary"],
  ["3", "Shri Ram Bhandare", "Member"],
  ["4", "Shri R. S. Mutalik", "Member"],
  ["5", "Shri U. N. Kalkundrikar", "Member"],
  ["6", "Shri P. G. Badkundri", "Member"],
  ["7", "Dr. V. A. Kulkarni", "Ex-Officio Member and Principal"],
];

const MemberModal = ({ member, onClose }) => {
  if (!member) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="relative bg-white rounded-lg shadow-xl max-w-lg w-full p-6">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-3xl text-gray-500 hover:text-black"
        >
          ×
        </button>

        <h2
          className="text-2xl text-center text-brand font-semibold mb-5"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {member.name}
        </h2>

        <img
          src={member.image}
          alt={member.name}
          className="w-full h-auto object-contain rounded-md"
        />
      </div>
    </div>
  );
};
const KlsTable = ({ title, roleHeader, rows, onRoleClick }) => (
  <section className="mt-10">
    <h3
      className="text-2xl md:text-3xl text-brand font-semibold mb-4"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      {title}
    </h3>

    <div className="overflow-x-auto bg-white border border-brand/15">
      <table className="w-full min-w-[560px] text-sm">
        <thead className="bg-brand text-surface font-sans-ui">
          <tr>
            <th className="w-20 px-4 py-3 text-left font-semibold tracking-wider">
              Sl. No
            </th>
            <th className="px-4 py-3 text-left font-semibold tracking-wider">
              Name
            </th>
            <th className="px-4 py-3 text-left font-semibold tracking-wider">
              {roleHeader}
            </th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row) => {
            const slNo = row.slNo || row[0];
            const name = row.name || row[1];
            const role = row.role || row[2];

            return (
              <tr key={`${slNo}-${name}`} className="odd:bg-surface/40">
                <td className="px-4 py-3 border-t border-brand/10 text-brand font-semibold">
                  {slNo}
                </td>

                <td className="px-4 py-3 border-t border-brand/10">
                  {name}
                </td>

                <td className="px-4 py-3 border-t border-brand/10">
                  {row.image ? (
                    <button
                      onClick={() => onRoleClick(row)}
                      className="text-brand font-semibold underline hover:text-brand/70"
                    >
                      {role}
                    </button>
                  ) : (
                    <span className="text-[#3a3a3a]">{role}</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </section>
);

const AboutKLS = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  return (
    <InnerLayout
      title="About Karnatak Law Society"
      image="/Campus/hero.jpg"
      breadcrumbs={[{ label: "About", to: "/about" }, { label: "About KLS" }]}
    >
      {/* your existing paragraph content here */}

      <KlsTable
        title="Members of KLS Board of Management"
        roleHeader="Role"
        rows={klsOfficeBearers}
        onRoleClick={setSelectedMember}
      />

      <KlsTable
        title="Governing Council (2025-2027)"
        roleHeader="Designation / Role"
        rows={governingCouncil}
        onRoleClick={setSelectedMember}
      />

      <MemberModal
        member={selectedMember}
        onClose={() => setSelectedMember(null)}
      />
    </InnerLayout>
  );
};

export default AboutKLS;